var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CanvasIndex',{attrs:{"height":500,"img-url":_vm.imgUrl,"width":500}})}
var staticRenderFns = []

export { render, staticRenderFns }